import React from 'react';
import { useTranslation } from 'react-i18next';

const HostContent = () => {
  const { t , i18n} = useTranslation()
  return (
    <div className="content px-4">
    <p>Managed & Supported</p>
    <h3 className='uppercase'>{t("Hosting solution")}</h3>
    <p className="mt-2">
    {t("Your website is only as strong as the platform it runs on. Our secure hosting services ensure your site is fast, stable, and always accessible to your audience. We provide high uptime, reliable servers, strong data protection, and scalability options that grow with your business needs. With us, you don’t just get hosting you get peace of mind knowing your digital presence is in safe hands.")}

    </p>
  </div>
  );
}

export default HostContent;
